<template>

<div class="login-container">
    <div class="item">
        <form class="login-form" @submit.prevent="LoginCustomer($event)" >
            <h1>Iniciar sesión</h1>
            <input type="text" class="form-control left" required="" name="email" placeholder="Correo electrónico">
            <input type="password" class="form-control left" required="" name="password" placeholder="Contraseña">
            <div class="mid-container">
                <router-link to='recuperar-usuario'>He realizado pedidos anteriormente por otro medio y quiero generar mi contraseña.</router-link>
                <br><br>
                <router-link to='olvide-mi-contraseña'>No recuerdo mi contraseña.</router-link>
                <br><br>
            </div>
            <div class="mid-container">
                <input class="ui blue button wide" type="submit" value="Iniciar Sesión" >
            </div>
            <br><br>
        </form>
    </div>

    <div class="item">
        <form class="register-form" @submit.prevent="RegisterCustomer($event)">
            <h1>Registrarme</h1>
            <input type="text" class="form-control left" required name="firstNames" id="firstNames" placeholder="Nombre(s)">
            <input type="text" class="form-control left" required name="lastNames" id="lastNames" placeholder="Apellido(s)">
            <input type="email" class="form-control left" required name="email" id="email" placeholder="Email">
            <input type="number" class="form-control left" required name="phone" id="phone" placeholder="Teléfono fijo (###) ###-####">
            <input type="number" class="form-control left" required name="mobile" id="mobile" placeholder="Teléfono celular (###) ###-####">
            <input type="password" class="form-control left" required name="password" id="password" placeholder="Contraseña">
            <input type="password" class="form-control left" required name="passwordConfirmation" id="passwordConfirmation" placeholder="Confirmar contraseña">
            <input type="text" class="form-control left" required name="referralCode" id="referralCode" placeholder="" value="0" hidden>
            <select name="marketingStrategy" id="marketingStrategy" class="form-control left">
                <option selected disabled >¿Cómo se enteró de nosotros?</option>
                <option v-for="(data,index) in marketingStrategies" :key="index" :value="data.id">{{data.name}}</option>
            </select>
            <div class="mid-container">
                <div class="checkbox-container">
                    <input type="checkbox" ><b>Confirmo que he leído y acepto los Términos y Condiciones </b>
                </div>
                <input class="ui blue button wide" type="submit" value="Registrate">
            </div>
        </form>
    </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    name:'Login',
    methods:{
        ...mapActions(['LoginCustomer','RegisterCustomer'])
    },
    computed:{
        ...mapState(['marketingStrategies'])
    }
}
</script>

<style scoped>
@import '../variables.css';

.login-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    align-items:center;
    padding: 0rem 5rem 10rem 5rem;
    width: auto;
   
}
.login-form, .register-form{
    flex-basis: 50%;
    flex-grow: 1;
}
.item{
    display: flex;
    justify-content: center;
    flex-grow: 1;
    align-items: flex-start;
    width:50%;
}
.mid-container{
    width: 90%;
}
body form {
    background:transparent;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 1.25rem;
    box-sizing: border-box;
    width: 25rem;
    height: 30rem;
    border-radius: 0.625rem
   
}
@media (max-width: 60rem){
    .item{
        width: 100%;
    }
    .checkbox-container{
        width:90%;
    }
}

@media (max-width: 37.5rem){
    .login-container{
        padding: 0rem 1rem 10rem 1rem;
    }
    
}

form h1{
    width: 90%;
    text-align:left;
    color: var(--dark-gofarma);
    font-weight: bold;
}
.form-control {
    width: 90%;
    min-height: 2rem;
    padding: 0.312rem 0.625rem;
    line-height: 1.6;
    background-color: #fff;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    outline: 0;
    margin-bottom:1em;
    text-align: center;
    box-sizing: border-box;
  
}

.btn-positive {
    border-color: var(--strong-green) var(--strong-green) var(--strong-green);
    background-color:  var(--light-green);
    width: 90%;
}
.btn-primary {
    border-color: var(--blue-gofarma) var(--blue-gofarma) var(--blue-gofarma);
    background-color: var(--blue-gofarma);
    width: 90%;
}
.btn {
    display: inline-block;
    padding: 0.1875rem 0.5rem;
    margin-bottom: 0;
    line-height: 1.4;
    white-space: nowrap;
    background-image: none;
    border: 0.0625rem solid transparent;
    border-radius: 0.25rem;
    box-shadow: 0 0.0625rem 0.0625rem rgba(0,0,0,.06);
}
.btn {
    vertical-align: middle;
    -webkit-app-region: no-drag;
}

.btn-negative, .btn-positive, .btn-primary, .btn-warning {
    color: #fff;
    text-shadow: 0 0.0625rem 0.0625rem  rgba(0,0,0,.1);
}
</style>